import { fade } from "material-ui-deprecated/utils/colorManipulator"
import {
  greenA200,
  greenA400,
  greenA700,
  green500,
  green800,
  blue50,
  blue500,
  blue700,
  blue800,
  lightBlue300,
  cyanA400,
  pink500,
  red500,
  redA400,
  grey100,
  grey300,
  grey400,
  grey500,
  grey600,
  grey900,
  yellow700,
  yellowA400,
  red50,
  white,
  darkBlack,
  fullBlack
} from "material-ui-deprecated/styles/colors"
import getMuiTheme from "material-ui-deprecated/styles/getMuiTheme"

const proStyles = {
  fontFamily: "Roboto, Lato, Arial, sans-serif",
  palette: {
    primary1Color: blue500,
    primary2Color: blue700,
    primary3Color: blue800,
    accent1Color: greenA400,
    accent2Color: greenA700,
    accent3Color: green800,
    accent4Color: cyanA400,
    lightBlueBackground: blue50,
    textColor: grey900,
    secondaryTextColor: grey600,
    iconColor: grey500,
    toolbarIconColor: grey600,
    lightTextColor: grey500,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    hintColor: grey400,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: green500,
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack,
    black: grey900,
    white: white,
    error: pink500,
    success: green500,
    delete: pink500,
    deleteHover: red50,
    settingsColor: "#00314a",
    cancelButtonTextColor: grey900,
    neutralYellowColor: yellow700,
    backgroundColor: grey100,
    failureRed: red500,
    semiTransparent: "rgba(255, 255, 255, 0.50)",
    newAction: blue500
  },
  appBar: {
    height: 64,
    textColor: white,
    titleFontWeight: 300,
    color: blue500
  },
  toolbar: {
    backgroundColor: grey100,
    height: 64,
    color: grey900,
    hoverColor: grey100,
    titleFontSize: 22,
    iconColor: grey900,
    separatorColor: grey400,
    menuHoverColor: grey500
  },
  productDashboard: {
    positiveColor: greenA400,
    neutralColor: yellowA400,
    negativeColor: redA400
  },
  // toolbar: {
  //     backgroundColor: blue700,
  //     height: 64,
  //     color: white,
  //     hoverColor: grey100,
  //     titleFontSize: 22,
  //     iconColor: grey900,
  //     separatorColor: blue500,
  //     menuHoverColor: grey500,
  // },
  flatButton: {
    fontWeight: 400
  },
  svgIcon: {
    color: grey500
  },
  tabs: {
    // backgroundColor: white,
    // textColor: fade(blue500, 0.6),
    // selectedTextColor: blue500
  },
  snackbar: {
    textColor: white,
    backgroundColor: grey900,
    actionColor: lightBlue300
  },
  inkBar: {
    backgroundColor: blue500
  },
  toggle: {
    thumbOnColor: blue500,
    thumbOffColor: grey100,
    trackOnColor: fade(blue500, 0.5),
    trackOffColor: grey400
  },
  badge: {
    // color: palette.alternateTextColor,
    // textColor: palette.textColor,
    primaryColor: greenA400,
    // primaryTextColor: palette.alternateTextColor,
    secondaryColor: pink500
    // secondaryTextColor: pink500,
    // fontWeight: typography.fontWeightMedium,
  },
  timePicker: {
    color: blue500,
    // textColor: grey900,
    accentColor: blue700,
    clockColor: grey900,
    // clockCircleColor: palette.clockCircleColor,
    headerColor: blue700
    // selectColor: palette.primary2Color,
    // selectTextColor: palette.alternateTextColor,
  },
  tableRow: {
    // hoverColor: palette.accent2Color,
    // stripeColor: fade(lighten(palette.primary1Color, 0.5), 0.4),
    selectedColor: grey100
    // textColor: palette.textColor,
    // borderColor: palette.borderColor,
    // height: 48,
  }
}

export default getMuiTheme(proStyles)
